<template>
  <div v-show="isModalVisible" id="skillpasscomponent">
    <div class="row align-items-center mb-3">
      <div class="col-8">
        <div class="px-2">
          <div class="input-group search_tasks_txtbox">
            <input type="text" class="form-control" placeholder="Search Services or Skills" v-model="searchText" aria-label="Search tasks" @keyup.enter="dosearch()" />
            <div class="input-group-append">
              <span class="input-group-text" v-if="searchTextFlag"><i class="fa fa-close" aria-hidden="true" @click="clearText()"></i></span>
              <span class="input-group-text" v-else><i class="fa fa-search" aria-hidden="true" @click="dosearch()"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 p-0" style="padding-right: 5px !important;">
        <div class="text-right ">
          <a @click="openTaskList()">Skill Set</a>
        </div>
      </div>
      <div class="col-2 p-0" style="padding-right: 20px !important;">

      </div>
    </div>


    <div style="margin-bottom: 7px; float: left; width: 100%;" v-if="tasklists_loading == true && tasklists_focus_loading == true">
      <div class="col-3 p-0 section-title float-left">
          <PuSkeleton :count="1"></PuSkeleton>
      </div>
      <div class="col-3 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">
        <PuSkeleton :count="1"></PuSkeleton>
      </div>
    </div>


    <div class="col-md-12 p-0" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;" v-for="option in 3" v-if="tasklists_loading == true && tasklists_focus_loading == true">
      <div class="subtask-wrapper" style="padding-bottom: 5px;">
        <div class="pt-2">
          <div class="col-12 pl-2 pr-0 float-left" >
            <div class="pr-2">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-2 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-1 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;padding-left: 20px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-1 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;padding-left: 20px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="focusedSubtasks.length > 0" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          Focused Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    
    <!-- Focussed Tasklist -->

    
    <!-- Focussed Tasklist -->

    <div v-if="focusedSubtasks.length > 0" class="col-md-12 counter_subtask-list p-0" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;">
      <div v-for = "(focusedSubtask, fsindex) in focusedSubtasks">
        <div class="subtask-wrapper" :id="'subtask-wrapper-skill-' + focusedSubtask.id" style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight">
            <div class="col-12 p-0 float-left" >
              <div class="float-left p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                <b-link
                  v-b-toggle="'collapse-focused-skill-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIconSkill(focusedSubtask.id)">
                    <i class="fa fa-angle-down angle-class" :id="'angle-focused-skill-'+ focusedSubtask.id" aria-hidden="true" ></i>
                </b-link>
              </div>
              <div class="float-left col-4 p-0">
                <b-link
                  v-b-toggle="'collapse-focused-skill-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIconSkill(focusedSubtask.id)">
                    {{ focusedSubtask.name }}
                </b-link>
              </div>
              <div class="float-left p-0 text-center save-goal-button" style="width: 14%; padding-top: 1px !important;" >
                &nbsp;
              </div>
              <div class="float-left col-3" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="focusedSubtask.id != 99999" >
                <b-link
                  v-b-toggle="'collapse-focused-skill-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIconSkill(focusedSubtask.id)">
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + focusedSubtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px;">
                      {{ focusedSubtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
                </b-link>
              </div>
              <div class="float-left col-2 p-0" style="padding-top: 3px !important;" v-if="focusedSubtask.enableAddRep == true">
                &nbsp;
              </div>    
              <div class="float-right p-0 star-class" v-if="focusedSubtask.id != 99999" style=" width: 5%; margin-top: 2px;">
                <i class="fa fa-star"  aria-hidden="true"    data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; color: #ee4200;"></i>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>

          <b-collapse v-bind:id="'collapse-focused-skill-' + focusedSubtask.id" class="mt-2 " style="border-top: 1px solid #C8C7C8; float: left; width: 100%; margin-top: 0px !important;">
            <b-card>
              <div class="col-md-12 override-padding counter_heading-list heading-wrapper" v-if="focusedSubtask.headings.length > 0">
                <div v-for = "(focusedHeading, hindex) in focusedSubtask.headings">
                  <b-link  v-b-toggle="'collapse-focused-skill-' + focusedSubtask.id + '-' + focusedHeading.id"  variant="primary" size="sm" class="sub-heading"  @click="getFocusedFontIconSkill(focusedSubtask.id + '-' + focusedHeading.id)" style="border-bottom: 1px solid #C8C7C8; border-radius: 0; padding-right: 10px;">
                    <i class="fa fa-angle-up" :id="'angle-focused-skill-'+ focusedSubtask.id + '-' + focusedHeading.id" aria-hidden="true"></i>
                    {{ focusedHeading.name }}
                  </b-link>
                  <b-collapse v-bind:id="'collapse-focused-skill-' + focusedSubtask.id + '-' + focusedHeading.id" class="mt-2 task-wrapper">
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for="(task, index) in focusedHeading.tasks" :key="index" class="custom-checkbox">
                          <b-card class="modal-task">
                            <div class="row">
                              <div class=""  style="width: 71%; padding-left: 10px;">
                                <div class="float-left" style="width: 2.2%; margin-top: 5px; padding-left: 32px;" v-if="task.completed == 1">
                                  <input 
                                    class="custom-control-input"
                                    name="skill_pass_tasks"
                                    :value="task.id" 
                                    :id="task.id" 
                                    type="checkbox" 
                                    value="1"
                                    disabled="disabled"
                                    >
                                  <label :for="task.id" class="custom-control-label"></label>
                                </div>
                                <div class="float-left" style="width: 2.2%; margin-top: 2px; padding-left: 32px;" v-else>
                                  <input 
                                    class="custom-control-input"
                                    name="skill_pass_tasks"
                                    :value="task.id" 
                                    :id="task.id" 
                                    type="checkbox" 
                                    @click="changeSkillPassTasks(task.id, task.description, focusedSubtask.id, focusedSubtask.name, focusedHeading.id, focusedHeading.name, $event)"
                                    value="1"
                                    >
                                  <label :for="task.id" class="custom-control-label"></label>
                                </div>
                                <div class="float-right" style="width: 91.8%">
                                <div class="task-title" style="padding-left: 0; width: 96%;">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                </div>
                              </div>
                              <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                              <div v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                            </div>
                          </b-card>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="focusedSubtask.tasks.length > 0" style="margin-top: 5px;">
                <div v-for="(task, index) in focusedSubtask.tasks" :key="index" class="custom-checkbox">
                  <b-card class="modal-task">
                    <div class="row">
                      <div class=""  style="width: 71%; padding-left: 10px;">
                        <div class="float-left" style="width: 2.2%; margin-top: 5px; padding-left: 32px;" v-if="task.completed == 1">
                          <input 
                            class="custom-control-input"
                            name="skill_pass_tasks"
                            :value="task.id" 
                            :id="task.id" 
                            type="checkbox" 
                            value="1"
                            disabled="disabled"
                            >
                          <label :for="task.id" class="custom-control-label"></label>
                        </div>
                        <div class="float-left" style="width: 2.2%; margin-top: 2px; padding-left: 32px;" v-else>
                          <input 
                            class="custom-control-input"
                            name="skill_pass_tasks"
                            :value="task.id" 
                            :id="task.id" 
                            type="checkbox" 
                            @click="changeSkillPassTasks(task.id, task.description, focusedSubtask.id, focusedSubtask.name, '', '', $event)"
                            value="1"
                            >
                          <label :for="task.id" class="custom-control-label"></label>
                        </div>
                        <div class="float-right" style="width: 91.8%">
                        <div class="task-title" style="padding-left: 0; width: 96%;">
                          <span class="counter_task-list__counter"></span>
                          {{ task.description }}
                        </div>
                        </div>
                      </div>
                      <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                      <div  v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                    </div>
                  </b-card>
                </div>
                <div style="clear: both;"></div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>


    <div v-if="focusedSubtasks.length > 0 && tasklists_focus_loading == false" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          Remaining Skills
      </div>
    </div>
    <div v-else-if="tasklists_focus_loading == false && focusedSubtasks.length == 0 && searchTextFlag == true" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          All Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    <div v-else-if="tasklists_loading == false" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          All Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    <!-- Subtask Tasklist -->

    <div v-if="subtasks.length > 0 && directTasks == 1" class="col-md-12 counter_subtask-list" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;">
      <div v-for = "(subtask, stindex) in subtasks" >
        <div v-if="subtask.name == 'NULL'" class="subtask-wrapper" :id="'subtask-wrapper-' + subtask.id"  style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight" style="background-color: #F0F0F0;">
            <div class="col-12 p-0 float-left" >
              <div class="float-left col-4 p-0">
              </div>
              <div class="float-right col-3 mr-4 pr-1 pt-1" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="subtask.id != 99999" >
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + subtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px; ">
                      {{ subtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>
          <div style="clear: both;"></div> 

            <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="subtask.tasks.length > 0" style="margin-top: 5px;">
              <div v-for="(task, index) in subtask.tasks" :key="index" class="custom-checkbox">
                <b-card class="modal-task ">
                  <div class="row">
                    <div class=""  style="width: 71%; padding-left: 10px;">
                      <div class="float-left" style="width: 2.2%; margin-top: 5px; padding-left: 32px;" v-if="task.completed == 1">
                        <input 
                          class="custom-control-input"
                          name="skill_pass_tasks"
                          :value="task.id" 
                          :id="task.id" 
                          type="checkbox" 
                          value="1"
                          disabled="disabled"
                          >
                        <label :for="task.id" class="custom-control-label"></label>
                      </div>
                      <div class="float-left" style="width: 2.2%; margin-top: 2px; padding-left: 32px;" v-else>
                        <input 
                          class="custom-control-input"
                          name="skill_pass_tasks"
                          :value="task.id" 
                          :id="task.id" 
                          type="checkbox" 
                          @click="changeSkillPassTasks(task.id, task.description, subtask.id, subtask.name, '', '', $event)"
                          value="1"
                          >
                        <label :for="task.id" class="custom-control-label"></label>
                      </div>
                      <div class="float-right" style="width: 91.8%">
                      <div class="task-title" style="padding-left: 0; width: 96%;">
                        <span class="counter_task-list__counter"></span>
                        {{ task.description }}
                      </div>
                      </div>
                    </div>
                    <div v-if="task.goal.goal_rep && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                    <div v-if="task.goal.goal_rep_competency && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                  </div>
                </b-card>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
    </div>





    <div v-if="subtasks.length > 0" class="col-md-12 counter_subtask-list" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;"">
      <div v-for = "(subtask, stindex) in subtasks">
        <div v-if="subtask.name != 'NULL'" class="subtask-wrapper" :id="'subtask-wrapper-skill-' + subtask.id" style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight">
            <div class="col-12 p-0 float-left" >
              <div class="float-left p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                <b-link
                  v-b-toggle="'collapse-skill-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIconSkill(subtask.id)">
                  <i class="fa fa-angle-down angle-class" :id="'angle-skill-'+ subtask.id" aria-hidden="true" ></i>
                </b-link>
              </div>
              <div class="float-left col-4 p-0">
                <b-link
                  v-b-toggle="'collapse-skill-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIconSkill(subtask.id)">
                    {{ subtask.name }}
                </b-link>
              </div>
              <div class="float-left p-0 text-center save-goal-button" style="width: 14%; padding-top: 1px !important;" >
                &nbsp;
              </div>
              <div class="float-left col-3" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="subtask.id != 99999" >
                <b-link
                  v-b-toggle="'collapse-skill-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIconSkill(subtask.id)">
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + subtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px; ">
                      {{ subtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
                </b-link>
              </div>
              <div class="float-left col-2 p-0" style="padding-top: 3px !important;" v-if="subtask.enableAddRep == true">
                &nbsp;
              </div>    
              <div class="float-right p-0 star-class" v-if="subtask.id != 99999" style="margin-top: 2px; width: 5%;">
                <i class="fa fa-star-o" aria-hidden="true"   data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; "></i>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>
          <b-collapse v-bind:id="'collapse-skill-' + subtask.id" class="mt-2 " style="border-top: 1px solid #C8C7C8; float: left; width: 100%; margin-top: 0px !important;">
            <b-card>
              <div class="col-md-12 override-padding counter_heading-list heading-wrapper" v-if="subtask.headings.length > 0">
                <div v-for = "(heading, hindex) in subtask.headings">
                  <b-link v-b-toggle="'collapse-skill-' + subtask.id + '-' + heading.id"  variant="primary" size="sm" class="sub-heading"  @click="getFontIconSkill(subtask.id + '-' + heading.id)" style="border-bottom: 1px solid #C8C7C8; border-radius: 0; padding-right: 10px;">
                    <i class="fa fa-angle-up" :id="'angle-skill-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                    {{ heading.name }}
                  </b-link>
                  <b-collapse v-bind:id="'collapse-skill-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for="(task, index) in heading.tasks" :key="index" class="custom-checkbox">
                          <b-card class="modal-task">
                            <div class="row">
                              <div class=""  style="width: 71%; padding-left: 10px;">
                                <div class="float-left" style="width: 2.2%; margin-top: 5px; padding-left: 32px;" v-if="task.completed == 1">
                                  <input 
                                    class="custom-control-input"
                                    name="skill_pass_tasks"
                                    :value="task.id" 
                                    :id="task.id" 
                                    type="checkbox" 
                                    value="1"
                                    disabled="disabled"
                                    >
                                  <label :for="task.id" class="custom-control-label"></label>
                                </div>
                                <div class="float-left" style="width: 2.2%; margin-top: 2px; padding-left: 32px;" v-else>
                                  <input 
                                    class="custom-control-input"
                                    name="skill_pass_tasks"
                                    :value="task.id" 
                                    :id="task.id" 
                                    type="checkbox" 
                                    @click="changeSkillPassTasks(task.id, task.description, subtask.id, subtask.name, heading.id, heading.name, $event)"
                                    value="1"
                                    >
                                  <label :for="task.id" class="custom-control-label"></label>
                                </div>
                                <div class="float-right" style="width: 91.8%">
                                <div class="task-title" style="padding-left: 0; width: 96%;">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                </div>
                              </div>
                              <div v-if="task.goal.goal_rep && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                              <div  v-if="task.goal.goal_rep_competency && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                            </div>
                          </b-card>
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="col-md-12 override-padding counter_task-list " v-if="subtask.tasks.length == 0 && subtask.id == 99999" style="margin-top: 5px;">
                  <b-card class="modal-task " >
                    <div class="row">
                      <div class=""  style="width: 60%; padding-left: 80px;">
                        No other task added.
                      </div>
                    </div>
                  </b-card>  
                </div>

                <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="subtask.tasks.length > 0" style="margin-top: 5px;">
                  <div v-for="(task, index) in subtask.tasks" :key="index" class="custom-checkbox">
                    <b-card class="modal-task ">
                      <div class="row">
                        <div class=""  style="width: 71%; padding-left: 10px;">
                          <div class="float-left" style="width: 2.2%; margin-top: 5px; padding-left: 32px;" v-if="task.completed == 1">
                            <input 
                              class="custom-control-input"
                              name="skill_pass_tasks"
                              :value="task.id" 
                              :id="task.id" 
                              type="checkbox" 
                              value="1"
                              disabled="disabled"
                              >
                            <label :for="task.id" class="custom-control-label"></label>
                          </div>
                          <div class="float-left" style="width: 2.2%; margin-top: 2px; padding-left: 32px;" v-else>
                            <input 
                              class="custom-control-input"
                              name="skill_pass_tasks"
                              :value="task.id" 
                              :id="task.id" 
                              type="checkbox" 
                              @click="changeSkillPassTasks(task.id, task.description, subtask.id, subtask.name, '', '', $event)"
                              value="1"
                              >
                            <label :for="task.id" class="custom-control-label"></label>
                          </div>
                          <div class="float-right" style="width: 91.8%">
                          <div class="task-title" style="padding-left: 0; width: 96%;">
                            <span class="counter_task-list__counter"></span>
                            {{ task.description }}
                          </div>
                          </div>
                        </div>
                        <div v-if="task.goal.goal_rep && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div v-if="task.goal.goal_rep_competency && subtask.goalEdit == false" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                      </div>
                    </b-card>
                  </div>
                  <div style="clear: both;"></div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div class="col-12 text-align-center" style="margin-top: 30px; margin-bottom: 25px;">
        <button class="btn btn-primary btn-sm ma-blue-btn" @click="openSkillPassConfirmModal()">
          Skill Pass
        </button>
        <div class="col-12 bold" style="margin-top: 12px;" v-if="tasksCount == 1">
          <u>{{ tasksCount }} Task Selected</u>
        </div>
        <div class="col-12 bold" style="margin-top: 12px;" v-else>
          <u>{{ tasksCount }} Tasks Selected</u>
        </div>

      </div>


      <SkillPassConfirmModal :isModalVisible="isSkillPassConfirmModalVisible" 
      ref="isSkillPassConfirm"
      @close="isSkillPassConfirmModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading12 col-11">
          Skill Pass - {{ menteeShortName }}
          <br />
          Skill Set - {{ taskListsName }}
        </div>
        <div slot="body">
          <div class="col-12 override-padding">
            <div class="col-12 p-0" v-for="(subtask, sindex) in skillTaskSubtask" :key="sindex">
              <div class="col-12 p-0" v-if="subtask.tasks.length > 0">
                <div class="col-12 p-0 bold" style="padding-bottom: 5px !important;" v-if="subtask.name != 'NULL'">{{ subtask.name }}</div>
                <div class="col-12 p-0" v-for="(task, tindex) in subtask.tasks" :key="tindex">
                  <div class="col-12 p-0" style="padding-bottom: 10px !important;">
                    <div class="col-1 float-left p-0 custom-checkbox">
                      <input 
                        name="skill_pass_tasks"
                        value="1" 
                        :id="task.id"
                        type="checkbox"
                        checked="true" 
                        v-model="skill_pass_tasks"
                        class="custom-control-input"
                        @click="changeSkillPassTasks(subtask.id, '', task.id, $event)"
                        style="margin-top: 10px; margin-left: 7px;"
                        >
                      <label :for="task.id" class="custom-control-label" style="margin-left: 30px; margin-top: 5px;"></label>
                    </div>
                    <div class="col-11 skill-task-show float-left p-0" style="padding: 5px 10px !important;">{{ task.description }}</div>
                    <div style="clear: both;"></div>
                  </div>
                </div>
              </div>

              <div class="col-12 p-0" v-if="subtask.headings.length > 0">
                <div class="col-12 p-0" v-for="(heading, hindex) in subtask.headings" :key="hindex">
                  <div class="col-12 p-0" v-if="heading.tasks.length > 0">
                    <div class="col-12 p-0 bold" style="padding-bottom: 5px !important;">{{ subtask.name }} - {{ heading.name }}</div>
                    <div class="col-12 p-0" v-for="(task, tindex) in heading.tasks" :key="tindex">
                      <div class="col-12 p-0" style="padding-bottom: 10px !important;">
                        <div class="col-1 float-left p-0 custom-checkbox">
                          <input 
                            name="skill_pass_tasks"
                            value="1" 
                            :id="task.id"
                            type="checkbox"
                            checked="true" 
                            v-model="skill_pass_tasks"
                            class="custom-control-input"
                            @click="changeSkillPassTasks(subtask.id, heading.id, task.id, $event)"
                            style="margin-top: 10px; margin-left: 7px;"
                            >
                          <label :for="task.id" class="custom-control-label" style="margin-left: 30px; margin-top: 5px;"></label>
                        </div>
                        <div class="col-11 skill-task-show float-left p-0" style="padding: 5px 10px !important;">{{ task.description }}</div>
                        <div style="clear: both;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>

            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-12 p-0 text-align-center bold" style="font-size: 15px; margin-top: 10px;">
              Are you sure you want to skill pass?
            </div>
            <div class="col-12 p-0 text-align-center bold" style="padding-top: 4px !important; font-size: 15px;">
              "This change can not be undone"
            </div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div slot="footer" class="col-12 override-padding">
          <div class="col-12 p-0" >
            <div class="col-4 float-left p-0 text-left">
              <button type="submit" class="closeBtn" @click="closeModal()">Back</button> 
            </div>
            <div class="col-4 float-left p-0 text-align-center" v-if="tasksCount == 1">
              {{ tasksCount }} task selected
            </div>
            <div class="col-4 float-left p-0 text-align-center" v-else>
              {{ tasksCount }} tasks selected
            </div>
            <div class="col-4 float-left p-0 text-align-right">
              <button style="border-radius: 15px !important;" :disabled="disable_confirm_btn" type="submit" class="btn ma-blue-btn btn-md start-button-red" @click="onSubmit()">Confirm</button> 
            </div>
          </div>

        </div>
      </SkillPassConfirmModal>


  </div>
</template>

<script>
import axios from 'axios';
import SkillPassConfirmModal from '@/components/manager/skillPassConfirmModal.vue';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      loading: false,
      menteeFirstName: '',
      menteeShortName: '',
      repCount: '',
      repTasks: '',
      mentorsAssigned: [],
      viewAll: false,
      searchText: '',
      subtasks: [],
      focusedSubtasks: [],
      searchTextFlag: false,
      tasklists_loading: false,
      tasklists_focus_loading: false,
      isSkillPassConfirmModalVisible: false,
      taskListsName: '',
      menteeId: '',
      taskListId: '',
      skillTaskSubtask: [],
      skill_pass_tasks: 1,
      tasksCount: 0,
      menteeShortName: '',
      disable_confirm_btn: false,
      directTasks: 0,
    }
  },
  components: {
    SkillPassConfirmModal
  },
  computed: {
    
  },
  methods: {
    openTaskList(flag = 0) {
      this.$emit('openTaskListModal', flag);
    },
    closeModal() {
      this.isSkillPassConfirmModalVisible = false;
    },
    openSkillPassConfirmModal: function() {
      if(this.tasksCount == 0) {
        alert("Please select minimum one tasks to proceed");
        return false;
      }
      else {
        let element12 = document.getElementById('skillpasscomponent');  
        element12.scrollIntoView(true);
        setTimeout(() => { 
        this.isSkillPassConfirmModalVisible = true;
        }, 500);
      }
    },
    onSubmit() {
      if(this.tasksCount == 0) {
        alert("Please select minimum one tasks to proceed");
        return false;
      }
      else {
        this.disable_confirm_btn = true;
        axios('/skill-pass-insert',
           {
              method: 'POST',
              data:
              {
                mentee_id: this.menteeId,
                tasklist_id: this.taskListId,
                account_id: this.$store.state.user_accountid,
                subtask: this.skillTaskSubtask,
              },
           }
         )
        .then((resp) => {
          this.disable_confirm_btn = false;
          this.isSkillPassConfirmModalVisible = false;
          this.$emit('closeAddRep');
          this.openTaskList(1);
         })
        .catch(error => {
          this.disable_confirm_btn = false;
        });
      }      
    },

    calculateTasks: function() {
      this.tasksCount = 0;
      for(var i=0; i<this.skillTaskSubtask.length; i++) {
        for(var k=0; k<this.skillTaskSubtask[i].tasks.length; k++) {
          this.tasksCount = parseInt(this.tasksCount + 1);
        }
        for(var j=0; j<this.skillTaskSubtask[i].headings.length; j++) {
          for(var k=0; k<this.skillTaskSubtask[i].headings[j].tasks.length; k++) {
            this.tasksCount = parseInt(this.tasksCount + 1);
          }
        }
      }
    },
    appendTasks: function(tasklistId, subTaskId, subTaskName, headingId, headingName, taskId, taskDescription) {

      var subTaskFlag = 0;
      for(var i=0; i<this.skillTaskSubtask.length; i++) {
        if(this.skillTaskSubtask[i].id == subTaskId) {
          subTaskFlag = 1;
          if(headingId == '') {
            this.skillTaskSubtask[i].tasks.push({
              id: taskId,
              description: taskDescription,
            });
          } else {
            var headingTaskFlag = 0;
            for(var j=0; j<this.skillTaskSubtask[i].headings.length; j++) {
              if(this.skillTaskSubtask[i].headings[j].id == headingId) {
                headingTaskFlag = 1;
                this.skillTaskSubtask[i].headings[j].tasks.push({
                  id: taskId,
                  description: taskDescription,
                });
              }
            }
            if(headingTaskFlag == 0) {
              var hindex = this.skillTaskSubtask[i].headings.length;
              this.skillTaskSubtask[i].headings.push({
                id: headingId,
                name: headingName,
                tasks: [],
              });
              this.skillTaskSubtask[i].headings[hindex].tasks.push({
                id: taskId,
                description: taskDescription,
              });
            }
          }
        }
      }
      if(subTaskFlag == 0) {
        var index = this.skillTaskSubtask.length;
        this.skillTaskSubtask.push({
          id: subTaskId,
          name: subTaskName,
          headings: [],
          tasks: [],
        });
        if(headingId == '') {
          this.skillTaskSubtask[index].tasks.push({
            id: taskId,
            description: taskDescription,
          });
        }
        else {
          var hindex = this.skillTaskSubtask[index].headings.length;
          this.skillTaskSubtask[index].headings.push({
            id: headingId,
            name: headingName,
            tasks: [],
          });
          this.skillTaskSubtask[index].headings[hindex].tasks.push({
            id: taskId,
            description: taskDescription,
          });
        }
      }
      this.calculateTasks();
    },

    removeTasks: function(subTaskId, headingId, taskId) {
      for(var i=0; i<this.skillTaskSubtask.length; i++) {
        if(this.skillTaskSubtask[i].id == subTaskId) {
          if(headingId == '') {
            for(var k=0; k<this.skillTaskSubtask[i].tasks.length; k++) {
              if(this.skillTaskSubtask[i].tasks[k].id == taskId) {
                this.skillTaskSubtask[i].tasks.splice(k, 1);
              }
            }
          } else {
            for(var j=0; j<this.skillTaskSubtask[i].headings.length; j++) {
              if(this.skillTaskSubtask[i].headings[j].id == headingId) {
                for(var k=0; k<this.skillTaskSubtask[i].headings[j].tasks.length; k++) {
                  if(this.skillTaskSubtask[i].headings[j].tasks[k].id == taskId) {
                    this.skillTaskSubtask[i].headings[j].tasks.splice(k, 1);
                  }
                }
              }
            }
          }
        }
      }
      this.calculateTasks();
    },
    changeSkillPassTasks: function(taskId, taskDescription, subtaskId, subtaskName, headingId, headingName, event){
      if(event.target.checked == true) {
        this.appendTasks(this.taskListId, subtaskId, subtaskName, headingId, headingName, taskId, taskDescription);
      }
      else {
        this.removeTasks(subtaskId, headingId, taskId);
      }
    },

    getFontIconSkill(id) {
      if (document.getElementById('collapse-skill-' + id).style.display == "") {
        document.getElementById('angle-skill-'+ id).className = "fa fa-angle-down";
      } else {
        document.getElementById('angle-skill-'+ id).className = "fa fa-angle-left";
      }
    },
    getSecondFontIconSkill(id) {
      if (document.getElementById('collapse-skill-' + id).style.display == "") {
        document.getElementById('angle-skill-'+ id).className = "fa fa-angle-down angle-class";
        document.getElementById('subtask-wrapper-skill-'+ id).className = "subtask-wrapper";
      } else {
        document.getElementById('angle-skill-'+ id).className = "fa fa-angle-left angle-class";
        document.getElementById('subtask-wrapper-skill-'+ id).className = "subtask-wrapper bg-grey";
      }
    },  
    getFocusedFontIconSkill(id) {
      if (document.getElementById('collapse-focused-skill-' + id).style.display == "") {
        document.getElementById('angle-focused-skill-'+ id).className = "fa fa-angle-down";
      } else {
        document.getElementById('angle-focused-skill-'+ id).className = "fa fa-angle-left";
      }
    },
    getFocusedSecondFontIconSkill(id) {
      if (document.getElementById('collapse-focused-skill-' + id).style.display == "") {
        document.getElementById('angle-focused-skill-'+ id).className = "fa fa-angle-down angle-class";
        document.getElementById('subtask-wrapper-skill-'+ id).className = "subtask-wrapper";
      } else {
        document.getElementById('angle-focused-skill-'+ id).className = "fa fa-angle-left angle-class";
        document.getElementById('subtask-wrapper-skill-'+ id).className = "subtask-wrapper bg-grey";
      }
    },
    showFocusedSectionOfMentee() {
       this.focusedSubtasks = [];
       this.tasklists_focus_loading = true;
       axios.get('/mentee/focusedsection/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid)
        .then(response =>  {          
            this.focusedSubtasks = response.data.subtasks;        
            if(this.focusedSubtasks.length == 0) {
              this.tasklists_focus_loading = true; 
            }
            else {
              this.tasklists_focus_loading = false; 
            }
        })
        .catch(function(error) {

        });
    },
    showAssessmentofTasklist() {
       this.tasklists_loading = true;
       this.subtasks = [];
       axios.get('/desktop/mentees_tasklists_detail/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid)
        .then(response =>  {
            this.tasklists_loading = false;
            this.subtasks = response.data.subtasks;
            this.taskListsName = response.data.title;
            for(var i=0; i<this.subtasks.length; i++) {
              if(this.subtasks[i].directTask == 1) {
                this.directTasks = 1;
              }
            }
        })
        .catch(function(error) {

        });
    },
    getTaskListData(menteeId, taskListId, menteeShortName) {
      this.menteeId = menteeId;
      this.taskListId = taskListId;
      this.skillTaskSubtask = [];
      this.menteeShortName = menteeShortName;
      this.showFocusedSectionOfMentee();
      this.showAssessmentofTasklist();
    },
    clearText() {
      this.searchText = '';
      this.subtasks = [];
      this.focusedSubtasks = [];
      this.tasklists_loading = true;
      this.tasklists_focus_loading = true;
      this.searchTextFlag = false;
      this.showFocusedSectionOfMentee();
      this.showAssessmentofTasklist();
    },
    dovalidate() {
      var flag = 1;
      if(this.searchText == '') {
        alert("Please enter search text");
        flag = 0;
        return false;
      }
      if(this.searchText.length < 3) {
        alert("Search text should be minimum 3 characters");
        flag = 0;
        return false;
      }
      return flag;
    },
    dosearch() {
      var flag = this.dovalidate();
      if(flag == 1) {
       this.searchTextFlag = true;
       this.subtasks = [];
       this.focusedSubtasks = [];
       this.tasklists_loading = true;
       this.tasklists_focus_loading = true;
       axios.get('/desktop/mentees_tasklists_search/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid, {
          params: {
            searchText: this.searchText,
          }
        })
        .then(response =>  {
          this.loading = false;
          this.tasklists_loading = false;
          this.tasklists_focus_loading = false;
          this.subtasks = response.data.subtasks;
          for(var i=0; i<this.subtasks.length; i++) {
            if(this.subtasks[i].directTask == 1) {
              this.directTasks = 1;
            }
          }
          this.focusedSubtasks = response.data.focusSubtasks;
          this.repCount = response.data.rep_count;
        })
        .catch(function(error) {

        });
      }
        
    },  

  },
}
</script>

<style scoped>


.subtask-wrapper {
  border: 1px solid #C8C7C8;
  background-color: #FFF;
  float: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
}
.bg-grey {
  background-color: #F0F0F0;
}

.star-class {
  padding-top: 3px !important;
}
.heading-wrapper {
  border: 0;
  float: left;
  width: 95%;
  margin-bottom: 10px;
  margin-left: 4%;
  margin-right: 1%;
  border-radius: 5px;
}
.sub-heading {
  background: none;
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
  padding-top: 8px;
  padding-bottom: 4px;
  margin-left: 8px;
}
.sub-heading i {
  float: none;
}
a.sub-heading i{
  color: #002F42 !important;
  font-weight: normal;
  font-size: 14px;
  padding-left: 0px;
  padding-right: 10px;
  border-radius: 5px;

}
.task-wrapper .card {
  font-weight: normal;
  border: 0px solid #C8C7C8;
  background-color: #FFF;
  margin-left: 5px;
  margin-right: 5px;
}
.task_goal_text {
  padding-top: 5px;
}
.task-rep-button {
  height: 21px; width: 94%; font-size: 12px; padding: 0; border-radius: 4px; margin-top: 5px; margin-right: 5px;
}
.subtask-rep-button {
  height: 20px; width: 65%; font-size: 12px; padding: 0; border-radius: 4px; margin-top: 1px; margin-right: 5px; margin-left: 20px;
  color: #FFF;
}
.progress {
  background-color: #DDD;
}
.save-goal-button {
  color: #2EACEE;
  font-weight: bold;
  cursor: pointer;
  margin-top: 4px;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-color: #ced4da !important;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  cursor: pointer;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.section-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px !important;
}
.skill-task-show {
  border: 1px solid #EEE;
  box-shadow: 1px 1px 3px 3px #EEE;
  border-radius: 6px;
  padding: 5px 10px !important;
}
.start-button {
  color: #29A3E4 !important;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 15px !important;
  font-size: 13px !important;;
  font-weight: 900 !important;;
  padding: 10px 10px 10px 10px !important;
  line-height: 8px !important;;
  width: 87px;
}
.start-button-red {
  color: #fff;
  background-color: #EC511F !important;
  border: 1px solid #EC511F !important;
  border-radius: 10px !important;
  font-size: 13px !important;;
  font-weight: 900 !important;;
  padding: 10px 10px 10px 10px !important;
  line-height: 8px !important;;
  width: 87px; 
}
.sub-task-cont {
  margin-left: 15px;
  margin-right: 10px;
}
.form-control:focus {
  border-color: #ced4da;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_skillpass_component.vue